  import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
  import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

  export const vsObjectName = "machineManufacturer";

  const url = "/api/machines/MachineManufacturer";

  export const machineManufacturerLookupConfig = simpleLookupConfig(
    vsLookupManagementServiceProviderName,
    {
      name: vsObjectName,
      nameSingular: "Manufacturer",
      url,
    }
  );
